{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Шаблони",
    "DESCRIPTION": "Преглед на шаблоните за съобщения, синхронизирани от вашите кутии на WhatsApp. За да създадете или редактирате шаблон, направете го през вашия доставчик.",
    "COUNT": "{n} шаблон | {n} шаблона",
    "LEARN_MORE": "Научи повече за шаблоните на WhatsApp",
    "SYNC_TEMPLATES": "Синхронизиране на шаблони",
    "SYNC_SUCCESS": "Синхронизирането на шаблони започна за всички кутии на WhatsApp. Актуализациите може да отнемат няколко минути.",
    "PARTIAL_SYNC_ERROR": "Синхронизирането на шаблони започна за някои кутии на WhatsApp, но други не можаха да бъдат синхронизирани.",
    "SYNC_ERROR": "Синхронизирането на шаблони не можа да стартира. Моля, опитайте отново.",
    "SEARCH_PLACEHOLDER": "Търсене по съдържание или име...",
    "MANAGE_IN_META": "Управление в Meta",
    "LOADING": "Зареждане на шаблоните на WhatsApp...",
    "EMPTY": "Не са намерени шаблони на WhatsApp.",
    "NO_RESULTS": "Няма шаблони, отговарящи на филтрите ви.",
    "FETCH_ERROR": "Шаблоните на WhatsApp не можаха да бъдат заредени. Моля, опитайте отново.",
    "PARTIAL_FETCH_ERROR": "Някои шаблони на WhatsApp не можаха да бъдат заредени. Моля, опитайте отново.",
    "LAST_SYNC_ATTEMPT": "Последен опит за синхронизиране на {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Не е изпратен за одобрение от WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Всички кутии",
      "ALL_LANGUAGES": "Всички езици",
      "ALL_TYPES": "Всички типове"
    },
    "TYPES": {
      "TEXT": "Текст",
      "IMAGE": "Изображение",
      "VIDEO": "Видео",
      "DOCUMENT": "Документ",
      "CALL_TO_ACTION": "Призив за действие",
      "COPY_CODE": "Копиране на код"
    },
    "PREVIEW": {
      "TITLE": "Преглед на шаблон",
      "DESCRIPTION": "Преглед как изглежда този шаблон в WhatsApp.",
      "OPEN": "Преглед на {name}",
      "CLOSE": "Затваряне на прегледа",
      "DETAILS": "Детайли на шаблона",
      "STATUS": "Статус",
      "TYPE": "Тип съдържание",
      "CATEGORY": "Категория",
      "LANGUAGE": "Език",
      "INBOXES": "Кутии"
    }
  }
}
